import { Button, Checkbox, Form, Input, Upload, message, Modal } from "antd";
import React, { useState } from "react";
import {
  useGetImagePortfolioMutation,
  useDeleteImagePortfolioMutation,
  useGetPortfolioMutation,
  usePutUpdatePortfolioMutation,
  useDeletePortfolioMutation,
} from "./services/PortfolioSerivce/PortfolioService";
import { Link, useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import middlewareAuthenticator from "./utils/middlewareAuthenticator";
import LocalStorageService from "./utils/LocalStorageService";

type FormPortType = {
  description: string;
  title: string;
  url_website: string;
  image: string;
};

const EditData = () => {
  const navigate = useNavigate();
  const [id_portfolio, setIdPortfolio] = useState("");
  const [path_image, setPathImage] = useState("");

  const [isModalEidtOpen, setIsModalEditOpen] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [form] = Form.useForm();

  const [getImagePortfolio, result_data_image_port] =
    useGetImagePortfolioMutation();
  const [deleteImagePortfolio, result_delete_image] =
    useDeleteImagePortfolioMutation();
  const [getPortfolio, result_portfolio] = useGetPortfolioMutation();
  const [putUpdatePortfolio, result_update_portfolio] =
    usePutUpdatePortfolioMutation();
  const [deletePortfolio, result_delete_portfolio] =
    useDeletePortfolioMutation();

  const fnGetImagePortfolio = async () => {
    try {
      const result = await getImagePortfolio().unwrap();
      console.log(result);
    } catch (err) {
      console.log(err);
    }
  };
  const fnGetPortfolio = async () => {
    try {
      const result = await getPortfolio().unwrap();
      console.log(result);
    } catch (err) {
      console.log(err);
    }
  };

  const fnDeleteImage = async (id_image: string) => {
    try {
      const result = await deleteImagePortfolio({ id_image }).unwrap();
      if (result.status === 200) {
        fnGetImagePortfolio();
      }
      // console.log(result);
    } catch (err) {
      console.log(err);
    }
  };
  const fnDeletePortfolio = async (id: string) => {
    try {
      const result = await deletePortfolio({ id }).unwrap();
      if (result.status === 200) {
        fnGetPortfolio();
      }
      // console.log(result);
    } catch (err) {
      console.log(err);
    }
  };
  const fnUpdatePortfolio = async (
    title: string,
    url_website: string,
    description: string,
    image: string,
    id_port: string
  ) => {
    try {
      const result = await putUpdatePortfolio({
        title,
        url_website,
        description,
        image,
        id_port,
      }).unwrap();
      if (result.status === 200) {
        fnGetPortfolio();
      }
      // console.log(result);
    } catch (err) {
      console.log(err);
    }
  };

  //---------- Modal Edit

  const showModal = () => {
    setIsModalEditOpen(true);
  };

  const handleCancel = () => {
    setIsModalEditOpen(false);
  };

  const onFinish = (values: FormPortType) => {
    if (id_portfolio) {
      fnUpdatePortfolio(
        values.title,
        values.url_website,
        values.description,
        values.image,
        id_portfolio
      );
    }

    // console.log("Edit Finish", values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const modal_edit = (
    <>
      <Modal
        title="Edit"
        open={isModalEidtOpen}
        closable={true}
        // onOk={() => handleOk()}
        onCancel={() => handleCancel()}
        footer={null}
      >
        <div>
          <Form
            form={form}
            name="basic"
            layout="vertical"
            style={{ width: "100%" }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            encType="multipart/form-data"
          >
            <Form.Item
              label="Title Website"
              name="title"
              hasFeedback={false}
              required={false}
              style={{
                width: "100%",
                marginBottom: 0,
              }}
              className="mt-[20px]"
              rules={[
                {
                  required: true,
                  message: "Please enter title",
                },
              ]}
            >
              <Input id="title" />
            </Form.Item>

            <Form.Item
              label="URL"
              name="url_website"
              hasFeedback={false}
              required={false}
              style={{
                width: "100%",
                marginBottom: 0,
              }}
              rules={[
                {
                  required: true,
                  message: "Please enter URL",
                },
              ]}
            >
              <Input id="url_website" />
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              hasFeedback={false}
              required={false}
              style={{
                width: "100%",
                marginBottom: 0,
              }}
              rules={[
                {
                  required: true,
                  message: "Please enter description",
                },
              ]}
            >
              <TextArea rows={4} id="description" />
            </Form.Item>

            <Form.Item
              label="Image Url"
              name="image"
              hasFeedback={false}
              required={false}
              style={{
                width: "100%",
                marginBottom: 0,
              }}
              rules={[
                {
                  required: true,
                  message: "Please enter image url",
                },
              ]}
            >
              <Input disabled={true} id="image" />
            </Form.Item>
            <Button
              className="text-[12px] p-0 h-[20px] px-[5px] mt-[5px]"
              onClick={() => fnGetImagePortfolio()}
            >
              Select Image
            </Button>
            <div className="grid grid-cols-4 gap-[10px] p-[10px] m-[10px] h-full max-h-[210px] overflow-auto">
              {result_data_image_port.data?.data?.map((item) => (
                <>
                  <img
                    className={`h-[100px] w-[100px] object-cover rounded-[10px] cursor-pointer duration-100 ${
                      item.url_image === path_image
                        ? "border-solid border-[2px] p-[2px] border-custom-primary-50 "
                        : ""
                    }`}
                    src={item.url_image}
                    onClick={() => {
                      setPathImage(item.url_image);
                      form.setFields([
                        {
                          name: "image",
                          value: item.url_image,
                        },
                      ]);
                    }}
                  />
                </>
              ))}
            </div>
            <div className="flex gap-[10px]">
              <Button
                type="primary"
                htmlType="submit"
                className="bg-custom-primary-100 mt-[10px] hover:!bg-custom-primary-75"
                // disabled={true}
              >
                Submit
              </Button>

              <Button
                type="primary"
                className="bg-white mt-[10px] text-custom-primary-75 hover:!bg-custom-primary-75"
                onClick={() => {
                  form.resetFields();
                  // setImageProfileUrl("");
                }}
              >
                Clear
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  );

  //----------

  const logOut = () => {
    navigate("/back-login");
    LocalStorageService.clearAccessToken();
  };

  const config = {
    title: "Delete?",
    content: null,
    // footer: null,
    closable: true,
    // onOk: () => {
    //   console.log("OK");
    // },
  };

  const config_modal_logout = {
    title: "Logout?",
    content: null,
    closable: true,
  };

  const delete_port = {
    title: "Delete Portfolio?",
    content: null,
    // footer: null,
    closable: true,
    // onOk: () => {
    //   console.log("OK");
    // },
  };

  const data_route = [
    {
      path: "/",
      title: "Home",
    },
    {
      path: "/back-admin",
      title: "Admin",
    },
    {
      path: "/back-admin/edit-data",
      title: "Edit data",
    },
    {
      path: "/back-admin/edit-image-design",
      title: "Image Design",
    },
  ];

  return (
    <div className="flex flex-col items-center ">
      <div className="flex flex-row items-start mx-[20px] mt-[30px] max-w-[700px] w-full justify-between xs:flex-col gap-[10px]">
        <div className="flex flex-row gap-[10px]">
          {data_route.map((item) => (
            <>
              <Link
                key={item.title}
                to={item.path}
                className="bg-custom-primary-100 text-[14px] px-[10px] rounded-[5px] hover:bg-white text-white hover:text-custom-gray-100 duration-200"
              >
                {item.title}
              </Link>
            </>
          ))}
        </div>

        <button
          onClick={async () => {
            const confirmed = await modal.confirm(config_modal_logout);
            if (confirmed) {
              logOut();
            }
          }}
          className="bg-white text-[14px] px-[10px] rounded-[5px] text-custom-primary-100 hover:text-white duration-200 hover:bg-custom-primary-100 "
        >
          Logout
        </button>
      </div>

      {modal_edit}
      <div className="flex flex-col items-start bg-custom-primary-25 w-full max-w-[700px] p-[20px] rounded-[15px] mt-[10px]">
        <h1 className="text-[20px] text-custom-gray-100">Edit Data</h1>
        <div className="flex flex-row gap-[10px]">
          <Button className="bg-white" onClick={() => fnGetImagePortfolio()}>
            List Image
          </Button>
          <Button className="bg-white" onClick={() => fnGetPortfolio()}>
            List Portfolio
          </Button>
        </div>

        <div className="grid grid-cols-5 gap-[20px] mt-[20px]">
          {contextHolder}

          {result_data_image_port.data?.data?.map((item) => (
            <>
              <div
                key={item._id}
                className="flex flex-col gap-[5px] w-[100px] h-[100px] relative"
              >
                <img
                  src={item.url_image}
                  className="object-cover rounded-[20px] w-[100px] h-[100px]"
                />
                <button
                  onClick={async () => {
                    const confirmed = await modal.confirm(config);
                    if (confirmed) {
                      console.log("Confirmed: ", item._id);
                      fnDeleteImage(item._id);
                    } else {
                      console.log("Cancel");
                    }
                  }}
                  className="bg-white flex justify-center items-center rotate-45 h-[20px] text-[16px] w-[20px] rounded-[50px] hover:bg-slate-200 absolute right-[-8px] top-[-8px]"
                >
                  +
                </button>
              </div>
            </>
          ))}

          {result_portfolio.data?.data?.map((item) => (
            <>
              <div
                key={item._id}
                className="flex flex-col gap-[5px] relative bg-white rounded-[10px] p-[5px]"
              >
                <p className="text-[12px] ">{item.title}</p>
                <img className="rounded-[5px]" src={item.image} />

                <div className="flex flex-row gap-[5px]">
                  <Button
                    className="text-[10px] w-[50px] h-[25px] bg-sky-400 p-0 hover:!text-white"
                    onClick={() => {
                      showModal();
                      setIdPortfolio(item._id);
                      form.setFields([
                        {
                          name: "title",
                          value: item.title,
                        },
                        {
                          name: "url_website",
                          value: item.url_website,
                        },
                        {
                          name: "description",
                          value: item.description,
                        },
                        {
                          name: "image",
                          value: item.image,
                        },
                      ]);
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={async () => {
                      const confirmed_port = await modal.confirm(delete_port);
                      if (confirmed_port) {
                        console.log("Confirmed: ", item._id);
                        //   fnDeleteImage(item._id);
                        fnDeletePortfolio(item._id);
                      } else {
                        console.log("Cancel");
                      }
                    }}
                    className="text-[10px] w-[50px] h-[25px] bg-red-400 p-0 hover:!text-white"
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

// export default EditData;
export default middlewareAuthenticator(EditData, { pageAction: "USE_AUTH" });
